/**
 * Route for `vertical-aware-fraud-rules-igaming-vs-fintech-vs-e`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { VerticalAwareFraudRulesIgamingVsFintechVsEPage } from "../features/vertical-aware-fraud-rules-igaming-vs-fintech-vs-e/VerticalAwareFraudRulesIgamingVsFintechVsEPage";

export const verticalAwareFraudRulesIgamingVsFintechVsERoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/vertical-aware-fraud-rules-igaming-vs-fintech-vs-e",
	component: VerticalAwareFraudRulesIgamingVsFintechVsEPage,
});

export default verticalAwareFraudRulesIgamingVsFintechVsERoute;
